"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_CORRECTION = exports.NO_KIWI_ACCOUNT = exports.HAS_KIWI_ACCOUNT = exports.FARE_LOCK_SCREEN_SHOWN = exports.INTRO_SCREEN_SHOWN = exports.CONTINUE_TO_PASSWORD = exports.CONTINUE_WITH_EMAIL = exports.REQUIRED_LOGIN_CONTINUE_AS_GUEST_CLICKED = exports.REQUIRED_LOGIN_SIGN_IN_CLICKED = exports.CRITICAL_LOGIN_ERROR = exports.LOGIN_STEP_FAILED = exports.LOGIN_PATH_FULFILLED = exports.LOGIN_ABANDONED = exports.GET_SIMPLE_TOKEN = exports.SIMPLE_TOKEN_RETRIEVED = exports.REGISTRATION_SENT = exports.LOGIN_VIA_GOOGLE_FAILED = exports.LOGIN_VIA_FACEBOOK_FAILED = exports.LOGIN_VIA_GOOGLE = exports.OTP_RESEND = exports.OTP_VERIFY_SUCCESS = exports.OTP_VERIFY_FAILED = exports.OTP_LOGIN_FAILED = exports.OTP_LOGIN_SUCCESS = exports.APPLE_LINK_SUCCESS = exports.APPLE_LINKING_INITIALIZED = exports.APPLE_LINK_FAILED = exports.LOGIN_VIA_APPLE_FAILED = exports.LOGIN_VIA_APPLE = exports.LOGIN_VIA_FACEBOOK = exports.CHANGE_EMAIL = exports.MAGIC_LINK_SENT = exports.RESET_PASSWORD_NOT_VERIFIED = exports.RESET_PASSWORD_REQUESTED = exports.SIGN_IN_NOT_VERIFIED = exports.SIGN_IN_INVALID_LOGIN = exports.SIGN_IN_BLOCKED_TEMPORARILY = exports.LOGGED_WITH_ACCOUNT = exports.SCREEN_CHANGED = exports.MAGIC_LOGIN_MODAL_SHOWN = void 0;
const MAGIC_LOGIN_MODAL_SHOWN = {
  category: "login",
  action: "modal shown",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.MAGIC_LOGIN_MODAL_SHOWN = MAGIC_LOGIN_MODAL_SHOWN;
const SCREEN_CHANGED = {
  category: "login",
  action: "continue",
  destinations: {
    bigQuery: true
  }
};
exports.SCREEN_CHANGED = SCREEN_CHANGED;
const LOGGED_WITH_ACCOUNT = {
  category: "login",
  action: "successful",
  destinations: {
    datadog: true,
    bigQuery: true,
    exponea: true
  }
};
exports.LOGGED_WITH_ACCOUNT = LOGGED_WITH_ACCOUNT;
const SIGN_IN_BLOCKED_TEMPORARILY = {
  category: "login",
  action: "sign in error user blocked",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.SIGN_IN_BLOCKED_TEMPORARILY = SIGN_IN_BLOCKED_TEMPORARILY;
const SIGN_IN_INVALID_LOGIN = {
  category: "login",
  action: "sign in error incorrect credentials",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.SIGN_IN_INVALID_LOGIN = SIGN_IN_INVALID_LOGIN;
const SIGN_IN_NOT_VERIFIED = {
  category: "login",
  action: "sign in error not verified",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.SIGN_IN_NOT_VERIFIED = SIGN_IN_NOT_VERIFIED;
const RESET_PASSWORD_REQUESTED = {
  category: "login",
  action: "reset password requested",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.RESET_PASSWORD_REQUESTED = RESET_PASSWORD_REQUESTED;
const RESET_PASSWORD_NOT_VERIFIED = {
  category: "login",
  action: "reset password error not verified",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.RESET_PASSWORD_NOT_VERIFIED = RESET_PASSWORD_NOT_VERIFIED;
const MAGIC_LINK_SENT = {
  category: "login",
  action: "magic link sent",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.MAGIC_LINK_SENT = MAGIC_LINK_SENT;
const CHANGE_EMAIL = {
  category: "login",
  action: "change email",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.CHANGE_EMAIL = CHANGE_EMAIL;
const LOGIN_VIA_FACEBOOK = {
  category: "login",
  action: "login via facebook provider",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_FACEBOOK = LOGIN_VIA_FACEBOOK;
const LOGIN_VIA_APPLE = {
  category: "login",
  action: "login via apple provider",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_APPLE = LOGIN_VIA_APPLE;
const LOGIN_VIA_APPLE_FAILED = {
  category: "login",
  action: "login via apple failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_APPLE_FAILED = LOGIN_VIA_APPLE_FAILED;
const APPLE_LINK_FAILED = {
  category: "login",
  action: "apple link account failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.APPLE_LINK_FAILED = APPLE_LINK_FAILED;
const APPLE_LINKING_INITIALIZED = {
  category: "login",
  action: "apple account linking initialized",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.APPLE_LINKING_INITIALIZED = APPLE_LINKING_INITIALIZED;
const APPLE_LINK_SUCCESS = {
  category: "login",
  action: "apple account successfully linked",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.APPLE_LINK_SUCCESS = APPLE_LINK_SUCCESS;
const OTP_LOGIN_SUCCESS = {
  category: "login",
  action: "one time passcode login succeded",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OTP_LOGIN_SUCCESS = OTP_LOGIN_SUCCESS;
const OTP_LOGIN_FAILED = {
  category: "login",
  action: "one time passcode login failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OTP_LOGIN_FAILED = OTP_LOGIN_FAILED;
const OTP_VERIFY_FAILED = {
  category: "login",
  action: "one time passcode verification failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OTP_VERIFY_FAILED = OTP_VERIFY_FAILED;
const OTP_VERIFY_SUCCESS = {
  category: "login",
  action: "one time passcode verification succeeded",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OTP_VERIFY_SUCCESS = OTP_VERIFY_SUCCESS;
const OTP_RESEND = {
  category: "login",
  action: "one time passcode resent",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.OTP_RESEND = OTP_RESEND;
const LOGIN_VIA_GOOGLE = {
  category: "login",
  action: "login via google provider",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_GOOGLE = LOGIN_VIA_GOOGLE;
const LOGIN_VIA_FACEBOOK_FAILED = {
  category: "login",
  action: "login via facebook failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_FACEBOOK_FAILED = LOGIN_VIA_FACEBOOK_FAILED;
const LOGIN_VIA_GOOGLE_FAILED = {
  category: "login",
  action: "login via google failed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_VIA_GOOGLE_FAILED = LOGIN_VIA_GOOGLE_FAILED;
const REGISTRATION_SENT = {
  category: "login",
  action: "registration sent",
  destinations: {
    datadog: true,
    bigQuery: true,
    exponea: true
  }
};
exports.REGISTRATION_SENT = REGISTRATION_SENT;
const SIMPLE_TOKEN_RETRIEVED = {
  category: "login",
  action: "simple token retrieved",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.SIMPLE_TOKEN_RETRIEVED = SIMPLE_TOKEN_RETRIEVED;
const GET_SIMPLE_TOKEN = {
  category: "login",
  action: "get simple token",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.GET_SIMPLE_TOKEN = GET_SIMPLE_TOKEN;
const LOGIN_ABANDONED = {
  category: "login",
  action: "login abandoned",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.LOGIN_ABANDONED = LOGIN_ABANDONED;
const LOGIN_PATH_FULFILLED = {
  category: "login",
  action: "login path fulfilled",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.LOGIN_PATH_FULFILLED = LOGIN_PATH_FULFILLED;
const LOGIN_STEP_FAILED = {
  category: "login",
  action: "request failed",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.LOGIN_STEP_FAILED = LOGIN_STEP_FAILED;
const CRITICAL_LOGIN_ERROR = {
  category: "login",
  action: "critical error",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.CRITICAL_LOGIN_ERROR = CRITICAL_LOGIN_ERROR;
const REQUIRED_LOGIN_SIGN_IN_CLICKED = {
  category: "login",
  action: "required login sign in button click",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.REQUIRED_LOGIN_SIGN_IN_CLICKED = REQUIRED_LOGIN_SIGN_IN_CLICKED;
const REQUIRED_LOGIN_CONTINUE_AS_GUEST_CLICKED = {
  category: "login",
  action: "required login continue as guest button click",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.REQUIRED_LOGIN_CONTINUE_AS_GUEST_CLICKED = REQUIRED_LOGIN_CONTINUE_AS_GUEST_CLICKED;
const CONTINUE_WITH_EMAIL = {
  category: "login",
  action: "continue with email",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.CONTINUE_WITH_EMAIL = CONTINUE_WITH_EMAIL;
const CONTINUE_TO_PASSWORD = {
  category: "login",
  action: "continue to password",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.CONTINUE_TO_PASSWORD = CONTINUE_TO_PASSWORD;
const INTRO_SCREEN_SHOWN = {
  category: "login",
  action: "Intro screen is shown",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.INTRO_SCREEN_SHOWN = INTRO_SCREEN_SHOWN;
const FARE_LOCK_SCREEN_SHOWN = {
  category: "login",
  action: "Fare lock screen is shown",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.FARE_LOCK_SCREEN_SHOWN = FARE_LOCK_SCREEN_SHOWN;
const HAS_KIWI_ACCOUNT = {
  category: "login",
  action: "email is not associated with account",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.HAS_KIWI_ACCOUNT = HAS_KIWI_ACCOUNT;
const NO_KIWI_ACCOUNT = {
  category: "login",
  action: "email is associated with account",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.NO_KIWI_ACCOUNT = NO_KIWI_ACCOUNT;
const EMAIL_CORRECTION = {
  category: "login",
  action: "user corrected email",
  destinations: {
    bigQuery: true,
    datadog: true
  }
};
exports.EMAIL_CORRECTION = EMAIL_CORRECTION;